import { makeStyles, Theme } from '@material-ui/core/styles';
export const useStyles = makeStyles((theme: Theme) => ({
  formContainer: {
    flex: 1,
  },
  inviterow: {
    padding: '24px 0',
    flexDirection: 'column',
  },
  rowemail: { padding: '0 0 24px 0' },
  row: {
    padding: '0 0 24px 0',
    flexDirection: 'column',
  },
  selectiontitle: {
    color: ' #000000',
    marginBottom: '24px',
    fontSize: '16px',
    fontWeight: 500,
  },
  input: {
    minWidth: 250,
    flexGrow: 1,
    fontSize: 16,
    color: 'rgb(0 0 0 / 87%)',
    '& .MuiInputBase-input.Mui-disabled': {
      color: 'rgb(0 0 0 / 87%)',
    },
  },
  selectOption: {
    height: '80px',
    width: '100%',
    overflowY: 'auto',
    marginBottom: '10px',
  },
  text: {
    margin: 'auto',
  },
  addBtn: {
    margin: '10px',
    width: '200px',
    color: 'blue',
  },
  block: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  btnrow: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(2),
    flexBasis: '45%',
    flexWrap: 'wrap',
    '@media (max-width: 1399px)': {
      flexBasis: '100%',
    },
  },
  btn1: {
    marginRight: '12px',
    padding: '12px 0',
    '& .MuiButton-label': {
      textTransform: 'none',
    },
    '& .MuiInputBase-input': {
      padding: ' 0',
      color: 'white',
    },
  },
  btn2: {
    // marginTop: theme.spacing(1),
    marginLeft: '12px',
    padding: '12px 0',
    '& .MuiButton-label': {
      textTransform: 'none',
    },
    '& .MuiInputBase-input': {
      padding: ' 0',
      color: 'white',
    },
  },
  bottomBtn: {
    height: '50px',
  },
  bottomBtn1: {
    height: '88px',
  },
  emailHeader: {
    background: '#363473',
    height: '50px',
    alignItems: 'center',
    marginTop: '5px',
    marginBottom: '4px',
    padding: '0 12px',
  },
  labels: {
    color: '#363473',
    fontSize: 24,
    fontWeight: 500,
    lineHeight: '160%',
    padding: '2px 0 0 40px',
  },
  details: {
    padding: '6px 0 0 40px',
    color: 'rgba(0, 0, 0, 0.64)',
  },
  btndetails: {
    color: 'rgba(0, 0, 0, 0.64)',
  },
  emailLink: {
    color: '#5081ff',
  },
  emailbtn: {
    borderBottom: '1px solid',
    padding: '0 0 8px 0',
    margin: '0 40px 0 40px',
    color: 'rgba(205, 218, 241, 1)',
  },
  system: {
    fontSize: '14px',
    padding: '4px 0 0 40px',
  },
  thanks: {
    '& .MuiInputBase-input': {
      fontWeight: 600,
      fontSize: '20px',
    },
  },
  admin: {
    '& .MuiInputBase-input': {
      color: 'rgba(0, 0, 0, 0.64)',
    },
  },
  callicon: {
    background: 'rgba(255, 255, 255, 0.1)',
    padding: '8px 7px',
    borderRadius: '4px',
    '& .MuiSvgIcon-root ': {
      color: 'white',
      height: '18px',
      widthh: '18px',
    },
  },
  footerText: {
    color: 'white',
    marginLeft: '8px',
  },
}));
